import automaticValidationSchema from "../../../Utilities/ValidationSchemaSetup/automaticValidationSchema";
import React, { useEffect, useState } from "react";
import createInitialValue from "../../../Utilities/InitialValuesSetup/createInitialValue";
// import { useParams } from "react-router-dom";
import axios from "axios";
// import CloseIcon from '@mui/icons-material/Close';
import Swal from "sweetalert2";
import _ from "lodash";
import { FieldArray, Form, Formik } from "formik";
import CreateQuoteObject from "../CreateQuoteObject";
// import { Box, Button, Grid, Typography } from "@mui/material"
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router";
// import CheckIcon from '@mui/icons-material/Check';
// import CircularProgressWithLabel from '../CircularProgress/CircularProgressWithLabel'
import CreateQuoteArray from "../CreateQuoteArray";
import FormikControl from "../../../Components/LifeInsFormikComponent/FormikControl";
// import { useNavigate, useParams } from "react-router";
// import { useHistory } from "react-router-dom";
import SaveChanges from "../../../Components/Modals/SortHealthInsureProduct";
// import reinitialize from "../../../Utilities/LifeInsuranceRequestBodies/ReInitializeValues/reinitialize";
import transData from "../../../Utilities/LifeInsuranceRequestBodies/ReInitializeValues/reinitializeUpdated";
import ShriRamreqbodyGen from "../../../Utilities/LifeInsuranceRequestBodies/CreateQuoteRequestBodies/ShriRamReqBodyGen";
import swal from "sweetalert2";
import finalreq from "./FinalReqbody";
import { Box, CircularProgress } from "@mui/material";
import updatePanField from "../../../Utilities/LifeInsuranceRequestBodies/UpdateConfig/lifePanFieldUpdate";
import CategoryHeader from "../../../Components/Headers/CategoryHeader";
import validateReqBdyGen from "../../../Utilities/LifeInsuranceRequestBodies/CreateQuoteRequestBodies/ValidateReqBody";

// import { useNavigate } from 'react-router';
function Validateproposal(props) {
  const [productName, setProductName] = useState("");
  const [productUrl, setProductUrl] = useState("");
  const [requestBody, setrequestBody] = useState({});
  const [newRequestBody, setNewRequestBody] = useState({});
  const [productDetails, setProductDetails] = useState({});
  const [responseData, setResponseData] = useState({});
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const [transferData, setTransferData] = useState({});
  const [depInd, setdepInd] = useState(1);
  const [progress, setProgress] = React.useState(0);
  const [loggedinUserid, setLoggeinUserid] = useState({});
  const [nomineeShare, setNomineeShare] = useState({});
  const [clickedSubmit, setClickedSubmit] = useState(false);
  const { id } = useParams();

  const productIdArray = id.split("*");
  const productRef = productIdArray[0];
  const transId = productIdArray[1];
  let navigate = useNavigate();

  //   let history = useHistory();

  var initialValues;
  var finalIni;
  if (
    Object.keys(productDetails).length > 0 &&
    Object.keys(transferData).length > 0
  ) {
    if (transferData.TotalPremium >= 50000) {
      console.log("Above 50", productDetails.requestBody.formFields.fields);
      const updatedProductDetails = updatePanField(productDetails);
      initialValues = createInitialValue(productDetails);
      // console.log('ini',initialValues)
      if (Object.entries(transferData).length > 0) {
        // finalIni=reinitialize(initialValues,transferData)
        finalIni = transData(transferData, initialValues);
        // console.log('jjj',finalIni)
      }
    } else {
      initialValues = createInitialValue(productDetails);
      // console.log('ini',initialValues)
      if (Object.entries(transferData).length > 0) {
        // finalIni=reinitialize(initialValues,transferData)
        finalIni = transData(transferData, initialValues);
        // console.log('jjj',finalIni)
      }
    }
  }

  var Fields = [];
  if (Object.keys(productDetails).length > 0) {
    productDetails.requestBody.formFields.fields.map((field, index) => {
      Fields.push(field);
    });
  }
  // console.log("Fields", Fields);

  if (Object.keys(productDetails).length > 0) {
    var SchemaArray = [];
    productDetails.requestBody.formFields.fields.map((field, index) => {
      let seperatearray = [];

      seperatearray.push(field);

      SchemaArray.push(seperatearray);
    });
  }

  var validationSchema = Yup.object().shape({});
  if (Object.keys(productDetails).length > 0) {
    validationSchema = automaticValidationSchema(SchemaArray[activeStep]);
  }
  // console.log("validSchema", validationSchema);

  const utility =
    "https://acuvisor.auxtomate.in/assets/js/proposalform/General-2.js";

  useEffect(() => {
    let productDetailsArray = [];
    let id_split = id.split("+");
    // setdepInd(1);
    // setProductDetails(VPJson);
    let domainExpress = "";
    let domainDjango = "";

    if (window.location.hostname === "localhost") {
      domainExpress = process.env.REACT_APP_LOCAL_EXPRESS;
      domainDjango = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domainExpress = process.env.REACT_APP_PRODUCTION_EXPRESS;
      domainDjango = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domainExpress = process.env.REACT_APP_UAT_EXPRESS;
      domainDjango = process.env.REACT_APP_UAT_DJANGO;
    }

    axios
      .get(
        `${domainExpress}/api/v1/lifeInsurance/validate-form/${productRef}`
        //`http://localhost:3002/api/v1/lifeInsurance/validate-form/${productRef}`
      )
      .then((response) => {
        if (response.status === 200) {
          console.log("response from node", response);
          setProductDetails(response.data);
        }
      });
    axios
      .get(
        `${domainDjango}/api/shriram/plp-validate-response/${transId}/`
        //`http://ec2-43-205-26-216.ap-south-1.compute.amazonaws.com/api/shriram/plp-validate-response/${id_split[0]}/`
      )
      .then((response) => {
        if (response.status === 200) {
          console.log("response in validate", response);
          setTransferData(response.data);
        }
      });

    /*  let utilityScript = document.createElement("script");
    utilityScript.src = utility;
    document.body.appendChild(utilityScript); */
  }, []);

  const verifyValidate = (ShriRamValues) => {
    console.log("within verifyvalidate", transferData.A_id);

    let domain = "";
    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO;
    }

    axios
      .post(
        `${domain}/api/life-insurance/validate-proposal/${transferData.A_id}/`,

        ShriRamValues
      )
      .then((response) => {
        console.log(response, "response in validate submit  form");
        /* if (response.data.ResultSet.ResponseCode === "200") { */
        if (response.data.ResultSet.ResponseCode !== "200") {
          alert(response.data.ResultSet.ResponseMsg);
          setClickedSubmit(false);
        } else {
          navigate(
            `/life-insurance/getbi/${transferData.bi_config_id}*${transId}*${response.data.validateProposalId}`
          );

          //setClickedSubmit(false);
        }
      }).catch(e=>{
        console.log('err',e.response.data)
        setClickedSubmit(false);
      })
  };

  const onSubmit = (values, actions) => {
    if (isLastStep()) {
      const ShriRamValues = validateReqBdyGen(values);

      console.log(ShriRamValues, "FinalRequest");
      console.log(transferData, "trans");

      let id_split = id.split("+");
      let updatedtrans = transferData;

     /*  let Laname;
      if (ShriRamValues.Request.Proposal.LifeType === "S") {
        Laname =
          `${ShriRamValues.Request.Proposal.LifeAssured.FirstName}` +
          " " +
          `${ShriRamValues.Request.Proposal.LifeAssured.MiddleName}` +
          " " +
          `${ShriRamValues.Request.Proposal.LifeAssured.LastName}`;
      } else {
        Laname =
          `${ShriRamValues.Request.Proposal.Proposer.FirstName}` +
          " " +
          `${ShriRamValues.Request.Proposal.Proposer.MiddleName}` +
          " " +
          `${ShriRamValues.Request.Proposal.Proposer.LastName}`;
      } */

      /* updatedtrans = { ...updatedtrans, ["LAName"]: Laname };
      console.log(updatedtrans, "transdata",Laname); */
      setClickedSubmit(true);

      let domain = "";
      if (window.location.hostname === "localhost") {
        //verifyValidate(ShriRamValues)
        domain = process.env.REACT_APP_LOCAL_DJANGO;
      } else if (window.location.hostname.trim() === "acuvisor.com") {
        domain = process.env.REACT_APP_PRODUCTION_DJANGO;
      } else {
        domain = process.env.REACT_APP_UAT_DJANGO;
      }

      axios
        .put(
          `${domain}/api/shriram/plp-validate-response/${transId}/`,
          //`http://ec2-43-205-26-216.ap-south-1.compute.amazonaws.com/api/shriram/plp-validate-response/${id_split[0]}/`,
          updatedtrans
        )
        .then((response) => {
          if (response.status === 200) {
            console.log("response in validate updated trans", response);
            if (response.data.message === "updated successfully") {
              //console.log('hhhh')
              verifyValidate(ShriRamValues);
            }
            // setTransferData(response.data);
          }
        });
    } else {
     // console.log("vvvvv", values.primaryDetails);
      //console.log("PAN", values.primaryDetails.LifeAssured);
      console.log("action", actions);

      let flag = false;
     
       if (values.primaryDetails.LifeType === "S") {
        console.log('LIfe',values.primaryDetails.LifeType )
        Object.entries(values.Proposer).map((proposer) => {
          Object.entries(values.primaryDetails.LifeAssured).map((primary) => {
            

            if (proposer[0] === primary[0]) {
              console.log("sss", proposer[0], primary[1]);

              values.Proposer = {
                ...values.Proposer,
                [`${proposer[0]}`]: primary[1],
              };

            } else {
              if (proposer[0] === "DateofBirth") {
                values.Proposer = {
                  ...values.Proposer,
                  [`${proposer[0]}`]: values.DateofBirth,
                };
              }
            }
          });
        });

        // console.log('hshs', values.Proposer[0], values.primaryDetails[0].LifeAssured)
      } /* else {
        console.log('dfa',values.primaryDetails.LifeType )
        Object.entries(values.Proposer).map(proposer => {
          values.Proposer = { ...values.Proposer, [`${proposer[0]}`]: '' }
        })
      }  */

      console.log("flag", flag);
      //setActiveStep(activeStep + 1);
      if (true) {
        setActiveStep(activeStep + 1);
        window.scrollTo(0, 0);
        actions.setTouched({});
        actions.setSubmitting(false);
      }
    }
  };

  const handleBack = () => {
    if (activeStep !== 0) {
      window.scrollTo(0, 0);
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      //formikContext.validateForm()
    } else {
      navigate(-1);
    }
  };
  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  // const iniVal = initialValues;
  // const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  //   backgroundColor:"#00008B",
  //     // theme.palette.mode === "dark" ? theme.palette.grey[700] : "",
  //   zIndex: 1,
  //   color: "white",
  //   width: 110,
  //   height: 35,
  //   fontSize:10,
  //   display: "flex",

  //   justifyContent: "center",

  //   alignItems: "center",
  //   ...(ownerState.active && {
  //     backgroundColor: "white",
  //     color: "black",
  //     borderWidth: "solid",
  //     borderColor: "black",
  //     boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  //   }),
  //   ...(ownerState.completed && {
  //     backgroundColor: "#00008B",
  //     color: "white",
  //     fontSize:10
  //   }),
  // }));
  const steps = [
    "PRIMARY DETAILS",
    "PED QUESTIONS",
    "PROPOSER DETAILS",
    "NOMINEE DETAILS",
  ];

  return (
    <>
     
      <div className="">
        <CategoryHeader title="Life Insurance" />
      </div>


      <div id="">
        <>
          <div>
          
            <div className="mx-auto life_stepper-container">
              <div className="Stepper_container">
                <div className="life_steppers">
                  {steps.map((field, index) => {
                    return (
                      <div
                        className={
                          activeStep === index
                            ? "life_active"
                            : `life_step${index}`
                        }
                        onClick={() => {
                          if (index < activeStep) setActiveStep(index);
                        }}
                      >
                        <p
                          className={
                            activeStep === index ? "active_text" : "text"
                          }
                        >
                          {field}
                        </p>
                      </div>
                    );
                  })}
                </div>
                <div className="lineCon">
                  <p className="stepper"></p>
                </div>
              </div>
            </div>

            <div className="">
              <div className="">
                {finalIni ? (
                  <Formik
                    initialValues={finalIni}
                   validationSchema={validationSchema}
                    enableReinitialize={true}
                    onSubmit={onSubmit}
                  >
                    {(formik) => {
                      console.log("formik val", formik);

                      return (
                        <Form autoComplete="off">
                          <div className="bg-white shadow-md rounded-card  form-container">
                            {Fields[activeStep].htmlElement === "Array" ? (
                              <CreateQuoteArray
                                Field={Fields[activeStep]}
                                name={Fields[activeStep].name}
                                nomineeShare={nomineeShare}
                                setNomineeShare={setNomineeShare}
                              />
                            ) : (
                              <CreateQuoteObject
                                Field={Fields[activeStep]}
                                name={Fields[activeStep].name}
                                nomineeShare={nomineeShare}
                                setNomineeShare={setNomineeShare}
                              />
                            )}
                          </div>

                          <div
                            /* className={
                              activeStep === 0
                                ? "button-secAt1tab"
                                : "button-sec"
                            } */
                            className="btn-sec position-fixed bottom-0 mt-3"
                          >
                            {clickedSubmit ? (
                              <CircularProgress
                                className="mx-auto"
                                size={48}
                                sx={{
                                  color: "red",
                                }}
                              />
                            ) : (
                              <>
                                <button
                                  className="Goback_btn"
                                  type="button"
                                  onClick={handleBack}
                                >
                                  Back
                                </button>
                                <button className="submitBtn" type="submit">
                                  {isLastStep() ? "Submit" : "Next"}
                                </button>
                              </>
                            )}
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                ) : (
                  <div>Loading....</div>
                )}
              </div>
            </div>
          </div>
        </>
      </div>
    </>
  );
}

export default Validateproposal;
